import React, { useState, useRef, useEffect } from 'react';
import { Bell } from 'lucide-react';
import { useNotifications } from '../hooks/useNotifications';
import { useAuth } from '../contexts/AuthContext';
import { NotificationPanel } from './NotificationPanel';

export const TopBar: React.FC = () => {
  const { notifications, dismissedNotifications, count, dashboardRole, dismiss, undismiss } = useNotifications();
  const { currentUser } = useAuth();
  const [panelOpen, setPanelOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  // Close panel on outside click
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setPanelOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  // Update tab title with notification count
  useEffect(() => {
    if (currentUser && window.location.pathname.startsWith('/artist/')) return;
    if (count > 0) {
      const label = dashboardRole === 'content' ? 'Offene Feedbacks'
        : dashboardRole === 'ads' ? 'Ad Alerts'
        : 'Aufgaben';
      document.title = `(${count}) ${label}`;
    } else {
      document.title = 'SwipeOS';
    }
    return () => { document.title = 'SwipeOS'; };
  }, [count, dashboardRole, currentUser]);

  return (
    <div className="h-11 flex-shrink-0 flex items-center justify-end px-4 border-b border-gray-800">
      <div ref={ref} className="relative">
        <button
          onClick={() => setPanelOpen(!panelOpen)}
          className="p-2 rounded-lg hover:bg-gray-800 text-gray-400 hover:text-white transition-colors relative"
        >
          <Bell className="h-5 w-5" />
          {count > 0 && (
            <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] flex items-center justify-center rounded-full bg-red-500 text-white text-[10px] font-bold px-1">
              {count > 99 ? '99+' : count}
            </span>
          )}
        </button>
        {panelOpen && (
          <NotificationPanel
            notifications={notifications}
            dismissedNotifications={dismissedNotifications}
            onDismiss={dismiss}
            onUndismiss={undismiss}
            onClose={() => setPanelOpen(false)}
          />
        )}
      </div>
    </div>
  );
};
